(function () {

    "use strict";

    function ManageListsController(hUser) {
        const self = this;

        self.$onInit = () => {
            self.brandId = hUser.getActiveBrandIdWithAccess();
        };
    }

    ManageListsController.$inject = ['hUser'];

    angular.module('harriMainApp').controller("ManageLists", ManageListsController);

})();